// extracted by mini-css-extract-plugin
export default {"wrapper":"page_wrapper__0kiYk","choices":"page_choices__fU4cR"};